import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { FormattedMessage } from "react-intl";

const IconTooltip = ({ tooltipMessageId, iconDefinition, iconClass }) => (
  <OverlayTrigger
    placement="auto"
    overlay={
      <Tooltip>
        <div className="text-start"><FormattedMessage id={tooltipMessageId}/></div>
      </Tooltip>
    }
  >
    <FontAwesomeIcon icon={iconDefinition} className={iconClass} />
  </OverlayTrigger>
);

export default IconTooltip;